import L from 'leaflet'
import "leaflet.markercluster";
import utils from "./utils";

'use strict';

class SearchResultMap {
  constructor(elem) {
    this.initSelectors(elem);
    this.mapInitialized = false;
    this.markers = [];
    this.locations = [];
    this.handleClickToggle = this.clickToggle.bind(this);
    this.events();
  }

  initSelectors(elem) {
    this.elem = elem;
    this.searchResultsList = document.querySelector('.search-results-list');
    this.searchResultsListItem = document.querySelectorAll('.search-results-village');
    this.searchResults = document.querySelector('.search-results');
    this.displayBtn = document.querySelectorAll('.js-search-results-map-toggle');
    this.closeBtn = document.querySelectorAll('.js-search-results-map-close');
  }

  initData() {
    this.locations = [];
    for (let village of this.searchResultsListItem) {
      let data = JSON.parse(village.dataset.location);
      this.locations.push(data);
    }
  }

  openVillage(url) {
    window.open(url, "_self");
  }

  highlightVillage(village) {
    const activeElement = this.searchResults.querySelector('.search-results-village.active');

    if(activeElement) activeElement.classList.remove('active');
    village.classList.add('active');
  }

  highlightMarker(marker, defaultIcon, activeIcon) {
    const activeMarker = this.markers.filter(marker => marker.options.active === true);
    if (activeMarker.length > 0) {
      activeMarker[0].options.active = false;
      activeMarker[0].setIcon(defaultIcon);
    }
    
    marker.setIcon(activeIcon);
    marker.options.active = true;

    return marker;
  }

  scrollToVillage(village) {
    const selectedVillage = village[0];
    this.highlightVillage(selectedVillage);
    selectedVillage.scrollIntoView({ behavior: "smooth", block: "center", inline: "start" });
  }

  moveToMarker(data, defaultIcon, activeIcon) {
    let marker = this.markers.find(obj => {
      return obj.id == data.id;
    });

    marker = this.highlightMarker(marker, defaultIcon, activeIcon);
    this.map.setView(marker.getLatLng(), 12);
    marker.openPopup();
  }

  events() {
    this.initData();
    document.addEventListener('reloadSearchResultMap', (ev) => {
      this.initSelectors(ev.detail.wrapper.querySelector('.js-search-results-map'));
      const resultsPage = this.searchResults.closest('.search-results-page');
      
      if (!document.getElementById('search-results-map').classList.contains('leaflet-container')) {
        this.initData();
        this.mapInitialized = false;
      }

      /* TODO: if active view mode is map add class active to elements to show it */
      if (resultsPage.dataset.activeViewMode === 'map') {
        this.elem.classList.add('active');
        this.searchResultsList.classList.add('active');
        this.searchResults.classList.add('active');

        if (!document.getElementById('search-results-map').classList.contains('leaflet-container')) {
          this.initMap();
        }
      }
    });

    for (let btn of this.closeBtn) {
      btn.addEventListener('click', e => {
        this.close(btn);
      });
    }

    for (let btn of this.displayBtn) {
      btn.removeEventListener('click', this.handleClickToggle);
      btn.addEventListener('click', this.handleClickToggle);
    }
  }

  clickToggle(event) {
    this.toggleMap(event.target);

    if (!this.mapInitialized) {
      this.initMap();
    }
  }

  close(btn) {
    const activeDisplayBtns = document.querySelectorAll('.js-search-results-map-toggle.active');
    activeDisplayBtns.forEach((activeDisplayBtn) => {
      activeDisplayBtn.classList.remove('active');
      if (activeDisplayBtn.dataset.toggleText) {
        this.toggleDisplayBtn(activeDisplayBtn);
      }
    });

    btn.classList.remove('active');
    if (btn.dataset.toggleText) {
      this.toggleDisplayBtn(btn);
    }

    this.elem.classList.remove('active');
    this.searchResultsList.classList.remove('active');
    this.searchResults.classList.remove('active');
  }

  toggleDisplayBtn(btn) {
    let displayBtnTxt = btn.textContent;
    let displayBtnAltTxt = `${btn.dataset.toggleText}`;
    btn.dataset.toggleText = displayBtnTxt;
    btn.textContent = displayBtnAltTxt;
    btn.classList.toggle('cta-icon-map');
    btn.classList.toggle('cta-icon-list');
  }

  toggleMap(btn) {
    const resultsPage = this.searchResults.closest('.search-results-page');

    btn.classList.toggle('active');
    this.elem.classList.toggle('active');
    this.searchResultsList.classList.toggle('active');
    this.searchResults.classList.toggle('active');
    if (btn.dataset.toggleText) {
      this.toggleDisplayBtn(btn);
    }

    if (this.mapInitialized) {
      this.map.fitBounds(this.mapBounds, { padding: [30, 30] });
    }
    
    resultsPage.dataset.activeViewMode = this.elem.classList.contains('active') ? 'map' : 'list';
  }

  mapPopup(data) {
    return `<div class='p-xs'>
      <h2 class='fs-xxs c-darker'>${data.title}</h2>
      <p class="fs-xxxs fs-xxs@>md">${data.price}</p>
    </div>`;
  }

  mapTooltip(data) {
    return `<div class='p-xs ta-c'>
      <h2 class='fs-xxs fw-600 m-no c-darker'>${data.title}</h2>
      <p class="fs-xxxs m-no fs-xxs@>md">${data.price}</p>
    </div>`;
  }

  initMap() {
    this.mapInitialized = true;

    const tiles = L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
      attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors, Points &copy 2012 LINZ',
      maxZoom: 20
    });

    const latlng = L.latLng(-50.82, 155.24);
    this.map = L.map('search-results-map', { center: latlng, zoom: 12, layers: [tiles] });

    const customIcon = L.icon({
      iconUrl: '/themes/siblu/dist/assets/svg/marker.svg',
      shadowUrl: null,
      iconSize: [20, 30], // size of the icon
      shadowSize: [50, 64], // size of the shadow
      iconAnchor: [-0, 0], // point of the icon which will correspond to marker's location
      shadowAnchor: [0, 0], // the same for the shadow
      popupAnchor: [7, -0] // point from which the popup should open relative to the iconAnchor
    });

    const customActiveIcon = L.icon({
      iconUrl: '/themes/siblu/dist/assets/svg/marker-active.svg',
      shadowUrl: null,
      iconSize: [41, 62], // size of the icon
      shadowSize: [50, 64], // size of the shadow
      iconAnchor: [-0, 0], // point of the icon which will correspond to marker's location
      shadowAnchor: [0, 0], // the same for the shadow
      popupAnchor: [7, -0] // point from which the popup should open relative to the iconAnchor
    });

    const markerClusterGroup = L.markerClusterGroup({ disableClusteringAtZoom: 12, spiderfyOnMaxZoom: false });

    this.markers = [];
    for (let i = 0; i < this.locations.length; i++) {
      let location = this.locations[i];
      let village = [...this.searchResultsListItem].filter(el => {
        const id = el.id;
        return id == location.id;
      });
      if (village) {
        let marker = L.marker(L.latLng(location.lat, location.lng), { icon: customIcon });
        marker.id = location.id;
        
        marker.addEventListener('click', e => {
          if (utils.mq.md.matches) {
            this.openVillage(location.url);
          } else {
            marker = this.highlightMarker(marker, customIcon, customActiveIcon);

            this.scrollToVillage(village);
            this.map.setView(marker.getLatLng());
          }
        });
  
        village[0].addEventListener('click', e => {
          this.highlightVillage(village[0]);
          this.moveToMarker(location, customIcon, customActiveIcon);
        });
  
        if (!utils.mq.md.matches) {
          // marker.bindPopup(this.mapPopup(location));
          marker.bindTooltip(this.mapTooltip(location), { direction: 'top', offset: [10, -10] });
        }

        markerClusterGroup.addLayer(marker);
        this.markers.push(marker);
      }
    }

    this.mapBounds = markerClusterGroup.getBounds();
    this.map.fitBounds(this.mapBounds, { maxZoom: 12, padding: [30, 30] });
    this.map.addLayer(markerClusterGroup);
  }
}

const searchResultMapEl = document.querySelector('.js-search-results-map');
if (searchResultMapEl && typeof searchResultMapEl.SearchResultMap === 'undefined') {
  searchResultMapEl.SearchResultMap = new SearchResultMap(searchResultMapEl);
}
